import { graphql } from 'react-apollo'
import Models           from '/models/index'


#
# Queries
#
import index    from './queries/index.gql'
import show     from './queries/show.gql'
import changes  from './queries/changes.gql'
import emails   from './queries/emails.gql'

export withTransfers = graphql index,
  options: (props)->
    { page, search, filters } = props.location.state or {}
    variables:
      page: page or 1
      search: search or undefined
      filters: filters or {}
  props: ({props, data})->
    { nodes, pagination } = data.transfers or {}
    transfers: Models.Transfer.parse nodes or []
    transfersPagination: pagination
    transfersLoading: data.loading

export withTransfer = graphql show,
  options: (props)->
    { id } = props.match.params
    variables:
      id: id
  props: ({props, data})->
    transfer: Models.Transfer.parse data.transfer
    transferLoading: data.loading

export withChanges = graphql changes,
  options: (props)->
    { page, search, filters } = props.location.state or {}
    variables:
      id: props.match.params.id
      page: page or 1
      search: search or undefined
      filters: filters or {}
  props: ({props, data})->
    { nodes, pagination } = data.transfer?.changes or {}
    changes: Models.Change.parse nodes or []
    changesPagination: pagination
    changesLoading: data.loading

export withEmails = graphql emails,
  options: (props)->
    { page, search, filters } = props.location.state or {}
    variables:
      id: props.match.params.id
      page: page or 1
      search: search or undefined
      filters: filters or {}
  props: ({props, data})->
    { nodes, pagination } = data.transfer?.emails or {}
    emails: Models.Email.parse nodes or []
    emailsPagination: pagination
    emailsLoading: data.loading

#
# Mutations
#
import transfers_rpc      from '/mutations/transfers/rpc.gql'

export withTransfersRPC = graphql transfers_rpc,
  props: ({ mutate })->
    transfers_rpc: (id, method)->
      {data: {transfer_rpc: {transfer, errors}}} = \
      await mutate variables: {id, method}
      {transfer, errors}
